import { Form } from '@unform/web';
import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  /* height: calc(10vh - 6rem); */
`;

export const FormWrapper = styled(Form)`
  > div:not(:last-child) {
    margin-bottom: 1rem;
  }
  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }
  /* display: flex;
  gap: 1.5rem; */
`;

const getColor = (props) => {
  if (props.isDragAccept) {
    return '#00e676';
  }
  if (props.isDragReject) {
    return '#ff1744';
  }
  if (props.isDragActive) {
    return '#2196f3';
  }
  return '#eeeeee';
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 0 0 0;
  width: 100%;
  align-content: center;
  align-self: center;
  button {
    margin-top: 1rem;
  }
`;

export const ContainerButton = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 1.5rem;

  align-items: center;
  justify-content: center;
  /* height: calc(10vh - 6rem); */
`;

export const ContainerStatus = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${(props) => getColor(props)};
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s ease-in-out;

  /* Estilos específicos para a impressão */
  /* @media print { */
  print {
    body * {
      visibility: hidden; /* Oculta todo o conteúdo */
    }

    #tabela,
    #tabela * {
      visibility: visible; /* Torna a tabela visível */
    }

    /* Opcional: Ajuste o tamanho da tabela para que ela se encaixe bem na página */
    table {
      width: 100%;
      border: 1px solid #000;
      border-collapse: collapse;
    }

    th,
    td {
      padding: 8px;
      border: 1px solid #000;
    }
  }

  > div:first-child {
    flex: 1;
  }
`;

export const DeleteButton = styled.button`
  background-color: #ffffff00;
  border: none;
  font-size: 1em;
  color: secondary;
`;
